import { render, staticRenderFns } from "./AddressBookEntries.vue?vue&type=template&id=5620462a&scoped=true&"
import script from "./AddressBookEntries.vue?vue&type=script&lang=js&"
export * from "./AddressBookEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620462a",
  null
  
)

export default component.exports